import React from "react";
import Meta from "../components/settings/Meta";
import DashboardLayout from "../components/dashboard/DashboardLayout"; // Import DashboardLayout
import EditMetricsTable from "../components/dashboard/EditMetricsTable";
import { requireAuth } from "./../util/auth";

function EditMetricsPage(props) {
  return (
    <>
      <Meta title="Update Your Metrics" />
      <DashboardLayout>
        <EditMetricsTable />
      </DashboardLayout>
    </>
  );
}

export default requireAuth(EditMetricsPage);
